import type { Route } from '@tanstack/react-location';
import { Navigate } from '@tanstack/react-location';
import HomePage from '../../Pages/HomePage';
import React from 'react';
import ClientsPage from '../../Pages/ClientsPage';
import InvoicingPage from '../../Pages/InvoicingPage';
import PaymentPage from '../../Pages/PaymentPage';
import ReportsPage from '../../Pages/ReportsPage';
import LoginPage from '../../Pages/LoginToAuth0Page';
import ChangePasswordPage from '../../Pages/ChangePasswordPage';
import ForgotPasswordPage from '../../Pages/ForgotPasswordPage';
import ResetPasswordPage from '../../Pages/ResetPasswordPage';
import UsersPage from '../../Pages/UsersPage';
import Authorized from '../../Pages/Authorized';
import JobsPage from '../../Pages/JobsPage';
import ClientDetailsPage from '../../Pages/ClientDetailsPage';
import TicketsPage from '../../Pages/TicketsPage';
import AnalyticsPage from '../../Pages/AnalyticsPage';
import QueuesPage from '../../Pages/QueuesPage';
import TowingPage from '../../Pages/TowingPage';
import CommunicationsPage from '../../Pages/CommunicationsPage';
import RegistrationsPage from '../../Pages/RegistrationsPage';

export const rootRoute: Route[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/home',
    element: <HomePage />
  },
  {
    path: '/clients',
    children: [
      {
        path: '/',
        element: <ClientsPage />
      },
      {
        path: '/:clientId',
        element: <ClientDetailsPage />
      }
    ]
  },
  {
    path: '/invoicing',
    element: <InvoicingPage />
  },
  {
    path: '/payment',
    element: <PaymentPage />
  },
  {
    path: '/reports',
    element: <ReportsPage />
  },
  {
    path: '/queues',
    element: <QueuesPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/change-password',
    element: <ChangePasswordPage />
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />
  },
  {
    path: '/users',
    element: <UsersPage />
  },
  {
    path: '/authorized',
    element: <Authorized />
  },
  {
    path: '/jobs',
    element: <JobsPage />
  },
  {
    path: '/tickets',
    element: <TicketsPage />
  },
  {
    path: '/analytics',
    element: <AnalyticsPage />
  },
  {
    path: '/towing',
    element: <TowingPage />
  },
  {
    path: '/communications',
    element: <CommunicationsPage />
  },
  {
    path: '/registrations',
    element: <RegistrationsPage />
  },
  {
    element: <Navigate to="/" />
  }
];
